import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from '@alefeducation/ui-elements-library-core';
import { ButtonsWrapper } from './style';

const Buttons = ({
  goBackToPreviousPage,
  buttonTooltip,
  toggleModal,
  isFormValid,
  assignmentMutation,
}) => {
  const { t } = useTranslation();
  const tooltipProps = buttonTooltip
    ? {
        'data-tip': `<span dir="ltr">${t(buttonTooltip)}</span>`,
        'data-html': true,
      }
    : {};

  return (
    <ButtonsWrapper>
      <Button
        variant={'secondary'}
        size={'lg'}
        onClick={() => {
          goBackToPreviousPage();
        }}
        data-testid="cancelButton"
      >
        {t('Cancel')}
      </Button>
      <span {...tooltipProps}>
        <Button
          variant={'secondary'}
          size={'lg'}
          data-testid="publishButton"
          onClick={toggleModal}
          disabled={!isFormValid}
        >
          {t('Publish')}
        </Button>
      </span>
      <span {...tooltipProps}>
        <Button
          variant={'primary'}
          size={'lg'}
          data-testid="saveButton"
          onClick={() => assignmentMutation('DRAFT')}
          disabled={!isFormValid}
        >
          {t('Save as Draft')}
        </Button>
      </span>
    </ButtonsWrapper>
  );
};

Buttons.propTypes = {
  goBackToPreviousPage: PropTypes.func.isRequired,
  buttonTooltip: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
  isFormValid: PropTypes.bool.isRequired,
  assignmentMutation: PropTypes.func.isRequired,
};

export default Buttons;
